import { createSlice } from "@reduxjs/toolkit";
import { fetchTeachersBuilder } from "./builder";

const initialState = {
  teachers: {
    data: [],
    total: 0,
  },
  fetchTeachersPending: false,
};

export const teacherSlice = createSlice({
  name: "teachers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    fetchTeachersBuilder(builder);
    builder.addCase("logout", () => initialState);
  },
});

export const selectTeachers = (state) => state.teachers.teachers;
export default teacherSlice.reducer;
